import { MFChannel } from '../../../Components/SDK';
import { showErrorToast, showSucessToast } from '../toast';
import logger from '../../../Helpers/logger';

export const handleReportChannel = async ({ channelId }) => {
    try {
        const res = await MFChannel.reportChannel({ channelId });
        if (res.statusCode === 200) {
            showSucessToast('Thanks for reporting');
        } else {
            showErrorToast(res?.message);
        }
    } catch (error) {
        logger.debug('Failed to mute the channel', error);
    }
};
